angular.module('iconoglobe')
.filter('capitalize', function() {
    return function(input) {
      return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
    };
})
.filter('shortenUrl', function(){
  return function(input){
    var s, index;
    index = 1;
    if(input !== undefined){
      s = input;
      s = s.split("/");
      for(var i in s){
        if(s[i].indexOf(".com") > -1 || s[i].indexOf("www.") > -1 ){
          index += parseInt(i);  
          break;
        };
      };
      //console.log(index)
      s = s.splice(0,index);
      s = s.join("/");
      return s;
    };
  };
})
.filter('trustUrl', function($sce) {
  return function(url) {
      return $sce.trustAsResourceUrl(url);
  };
});